import gsap from 'gsap'
import CustomEase from 'gsap/CustomEase'
import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

gsap.registerPlugin(CustomEase)

const SELECTORS = {
  adlamFullWidth: '.adlam-full-width',
  letters: '.js-adlam-full-width__letter'
}

class AdlamFullWidth {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.letters = this.element.querySelectorAll(SELECTORS.letters)

    this.init()
  }

  init() {
    this.registerEvents()
    this.addLetters()
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.ELEMENT_IN_VIEWPORT, elem => { this.triggerAnimation(elem) })
  }

  addLetters() {
    const letterUrl = `${unlocked.theme_dir}/blocks/adlam_full_width/assets/images/`
    const letterCount = 9
    let count = 0

    while (count < letterCount) {
      count++
      const img = document.createElement('img')
      img.src = `${letterUrl}Letter_${count}.png`
      img.classList.add('js-adlam-full-width__letter')
      img.classList.add('adlam-full-width__letter')
      img.classList.add(`--${count}`)
      img.dataset.num = count
      this.element.appendChild(img)
    }
  }

  triggerAnimation() {
    this.letters = this.element.querySelectorAll(SELECTORS.letters)

    this.letters.forEach(item => {
      item.setAttribute('tabindex', '-1')
      item.setAttribute('aria-hidden', 'true')
      const index = item.dataset.num
      const speedY = index + 10
      const speedX = index + 9.725
      const distanceY = `${index * 370 * -1}%`
      let distanceX = index * 50
      if (index <= 5) distanceX = distanceX * -1
      distanceX = `${distanceX}%`

      const yAnim = gsap.to(item, { duration: speedY, y: distanceY })
      const xAnim = gsap.to(item, { duration: speedX, x: distanceX })

      if (document.documentElement.classList.contains('reduced-motion')) {
        yAnim.pause()
        xAnim.pause()
      }

      this.emitter.on(GLOBAL_CONSTANTS.EVENTS.REDUCED_MOTION_CHANGE, (reducedMotion) => {
        if (reducedMotion) {
          yAnim.pause()
          xAnim.pause()
        } else {
          yAnim.play()
          xAnim.play()
        }
      })
    })
  }
}

export default {
  selector: SELECTORS.adlamFullWidth,
  Source: AdlamFullWidth
}
